import { render, staticRenderFns } from "./UserItemSettings.vue?vue&type=template&id=1f437251"
import script from "./UserItemSettings.vue?vue&type=script&lang=js"
export * from "./UserItemSettings.vue?vue&type=script&lang=js"
import style0 from "./UserItemSettings.vue?vue&type=style&index=0&id=1f437251&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports